// src/components/table/columnsConfig/sodPositionsColumns.js

export const getSodPositionsColumns = () => {
  return [
    {
      field: "Actions",
      label: "Actions",
      width: 80,
      align: "center",
      sortable: false,
    },
    {
      field: "StrategyType",
      label: "Strategy Type",
      width: 140,
      align: "left",
      sortable: true,
    },
    {
      field: "Strategy1",
      label: "Strategy 1",
      width: 160,
      align: "left",
      sortable: true,
    },
    {
      field: "Symbol",
      label: "Symbol",
      width: 160,
      align: "left",
      sortable: true,
    },
    {
      field: "Alias2",
      label: "Alias 2",
      width: 160,
      align: "left",
      sortable: true,
    },
    {
      field: "Start",
      label: "Start Quantity",
      width: 80,
      align: "right",
      sortable: true,
    },
    {
      field: "Local",
      label: "Currency",
      width: 60,
      align: "left",
      sortable: true,
    },
    {
      field: "settle_currency",
      label: "Settle Currency",
      width: 60,
      align: "left",
      sortable: true,
    },
    {
      field: "SecType",
      label: "Security Type",
      width: 120,
      align: "left",
      sortable: true,
    },
    {
      field: "StartPrc",
      label: "Start Price",
      width: 60,
      align: "right",
      sortable: true,
    },
    {
      field: "Ticker_Exchange_Code",
      label: "Ticker Exchange Code",
      width: 160,
      align: "left",
      sortable: true,
    },
    {
      field: "BB_Ticker_Code",
      label: "Bloomberg Ticker Code",
      width: 150,
      align: "left",
      sortable: true,
    },
    {
      field: "Price_Multiplier",
      label: "Price Multiplier",
      width: 100,
      align: "right",
      sortable: true,
    },
    {
      field: "Position_Multiplier",
      label: "Position Multiplier",
      width: 100,
      align: "right",
      sortable: true,
    },
    {
      field: "sec_type2",
      label: "Security Type 2",
      width: 120,
      align: "left",
      sortable: true,
    },
  ];
};

// Mobile-only headers for responsive design
export const MOBILE_HEADERS = ["StrategyType", "Strategy1", "Symbol"];
